import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import envConfig from '../../../envConfig';
import { mapToProduct } from '../../../classes/mappers/JsonMappers';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

const selectAllProducts = createSelector([
  (state) => state.products],
(products) => products.productList.map(
  (product) => mapToProduct(product),
));

const selectProductsByCategory = createSelector([
  (state) => state.products.productList,
  (productList, categoryId) => categoryId,
],
(productList, categoryId) => {
  const categoryProducts = productList.filter((product) => product.categoryId === categoryId);
  return categoryProducts.map((product) => mapToProduct(product));
});

const fetchProducts = createAsyncThunk(
  'securedApi/products/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/products`);
      return response.products;
    } catch (error) {
      return rejectWithValue({
        name: error.name,
        message: error.message,
        data: error.data,
      });
    }
  },
);

const initialState = {
  loading: true,
  loadingError: false,
  productList: [],
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    clearProductsSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, () => {
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.productList = action.payload;
        state.loading = false;
      })
      .addCase(fetchProducts.rejected, (state) => {
        state.loading = false;
        state.loadingError = true;
      });
  },
});

const { actions, reducer } = productsSlice;

export const { clearProductsSlice } = actions;
export {
  selectAllProducts,
  selectProductsByCategory,
  fetchProducts,
};
export default reducer;
